import React from 'react'
import styles from './CardIconMore.module.scss'

type Props = {
  size: number;
}

export function CardIconMore({ size }: Props) {
  return (
    <div className={styles.root}>
      <span className={styles.mainNumber}>{`+${size}`}</span>
    </div>
  )
}
